import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/details:tid',
    name: 'details',
    component: () => import('../views/details.vue')
  },
  {
    path: '/opinion',
    name: 'opinion',
    component: () => import('../views/opinion.vue')
  },
  {
    path: '/category/:cid/:tid',
    name: 'category',
    component: () => import('../views/category.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
